import { FilterDatePicker, FilterSelect } from '@/modules/common';
import {
  type EventFiltersType,
  type FiltersChangeType,
} from '@/modules/events/hooks';
import { EventOrderStatus, EventSmsStatus } from '@/modules/events/types';

const statusOptions = [
  { value: 'Sent', id: EventSmsStatus.Sent },
  { value: 'Failed', id: EventSmsStatus.Failed },
];

export const TableFilters = ({
  filters,
  onFilters,
}: {
  filters: EventFiltersType;
  onFilters: FiltersChangeType;
}) => {
  return (
    <div className="flex gap-4">
      <div className="flex-1">
        <FilterDatePicker
          value={filters.date}
          onChange={(value) => onFilters({ date: value })}
          label="Date"
        />
      </div>

      <div className="flex-1">
        <FilterSelect
          options={statusOptions}
          label="Status"
          value={filters.status}
          onChange={(value: EventOrderStatus) => onFilters({ status: value })}
        />
      </div>
    </div>
  );
};
